/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.lslFrame = (function() {

    /**
     * Properties of a lslFrame.
     * @exports IlslFrame
     * @interface IlslFrame
     * @property {number} timeStamp lslFrame timeStamp
     * @property {string|null} [event] lslFrame event
     * @property {lslFrame.IlslVector|null} [vector] lslFrame vector
     */

    /**
     * Constructs a new lslFrame.
     * @exports lslFrame
     * @classdesc Represents a lslFrame.
     * @implements IlslFrame
     * @constructor
     * @param {IlslFrame=} [properties] Properties to set
     */
    function lslFrame(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * lslFrame timeStamp.
     * @member {number} timeStamp
     * @memberof lslFrame
     * @instance
     */
    lslFrame.prototype.timeStamp = 0;

    /**
     * lslFrame event.
     * @member {string|null|undefined} event
     * @memberof lslFrame
     * @instance
     */
    lslFrame.prototype.event = null;

    /**
     * lslFrame vector.
     * @member {lslFrame.IlslVector|null|undefined} vector
     * @memberof lslFrame
     * @instance
     */
    lslFrame.prototype.vector = null;

    // OneOf field names bound to virtual getters and setters
    var $oneOfFields;

    /**
     * lslFrame value.
     * @member {"event"|"vector"|undefined} value
     * @memberof lslFrame
     * @instance
     */
    Object.defineProperty(lslFrame.prototype, "value", {
        get: $util.oneOfGetter($oneOfFields = ["event", "vector"]),
        set: $util.oneOfSetter($oneOfFields)
    });

    /**
     * Creates a new lslFrame instance using the specified properties.
     * @function create
     * @memberof lslFrame
     * @static
     * @param {IlslFrame=} [properties] Properties to set
     * @returns {lslFrame} lslFrame instance
     */
    lslFrame.create = function create(properties) {
        return new lslFrame(properties);
    };

    /**
     * Encodes the specified lslFrame message. Does not implicitly {@link lslFrame.verify|verify} messages.
     * @function encode
     * @memberof lslFrame
     * @static
     * @param {IlslFrame} message lslFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    lslFrame.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 5 =*/13).float(message.timeStamp);
        if (message.event != null && Object.hasOwnProperty.call(message, "event"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.event);
        if (message.vector != null && Object.hasOwnProperty.call(message, "vector"))
            $root.lslFrame.lslVector.encode(message.vector, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified lslFrame message, length delimited. Does not implicitly {@link lslFrame.verify|verify} messages.
     * @function encodeDelimited
     * @memberof lslFrame
     * @static
     * @param {IlslFrame} message lslFrame message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    lslFrame.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a lslFrame message from the specified reader or buffer.
     * @function decode
     * @memberof lslFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {lslFrame} lslFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    lslFrame.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.lslFrame();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.timeStamp = reader.float();
                    break;
                }
            case 2: {
                    message.event = reader.string();
                    break;
                }
            case 3: {
                    message.vector = $root.lslFrame.lslVector.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("timeStamp"))
            throw $util.ProtocolError("missing required 'timeStamp'", { instance: message });
        return message;
    };

    /**
     * Decodes a lslFrame message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof lslFrame
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {lslFrame} lslFrame
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    lslFrame.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a lslFrame message.
     * @function verify
     * @memberof lslFrame
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    lslFrame.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        var properties = {};
        if (typeof message.timeStamp !== "number")
            return "timeStamp: number expected";
        if (message.event != null && message.hasOwnProperty("event")) {
            properties.value = 1;
            if (!$util.isString(message.event))
                return "event: string expected";
        }
        if (message.vector != null && message.hasOwnProperty("vector")) {
            if (properties.value === 1)
                return "value: multiple values";
            properties.value = 1;
            {
                var error = $root.lslFrame.lslVector.verify(message.vector);
                if (error)
                    return "vector." + error;
            }
        }
        return null;
    };

    /**
     * Creates a lslFrame message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof lslFrame
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {lslFrame} lslFrame
     */
    lslFrame.fromObject = function fromObject(object) {
        if (object instanceof $root.lslFrame)
            return object;
        var message = new $root.lslFrame();
        if (object.timeStamp != null)
            message.timeStamp = Number(object.timeStamp);
        if (object.event != null)
            message.event = String(object.event);
        if (object.vector != null) {
            if (typeof object.vector !== "object")
                throw TypeError(".lslFrame.vector: object expected");
            message.vector = $root.lslFrame.lslVector.fromObject(object.vector);
        }
        return message;
    };

    /**
     * Creates a plain object from a lslFrame message. Also converts values to other types if specified.
     * @function toObject
     * @memberof lslFrame
     * @static
     * @param {lslFrame} message lslFrame
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    lslFrame.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.timeStamp = 0;
        if (message.timeStamp != null && message.hasOwnProperty("timeStamp"))
            object.timeStamp = options.json && !isFinite(message.timeStamp) ? String(message.timeStamp) : message.timeStamp;
        if (message.event != null && message.hasOwnProperty("event")) {
            object.event = message.event;
            if (options.oneofs)
                object.value = "event";
        }
        if (message.vector != null && message.hasOwnProperty("vector")) {
            object.vector = $root.lslFrame.lslVector.toObject(message.vector, options);
            if (options.oneofs)
                object.value = "vector";
        }
        return object;
    };

    /**
     * Converts this lslFrame to JSON.
     * @function toJSON
     * @memberof lslFrame
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    lslFrame.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for lslFrame
     * @function getTypeUrl
     * @memberof lslFrame
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    lslFrame.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/lslFrame";
    };

    lslFrame.lslVector = (function() {

        /**
         * Properties of a lslVector.
         * @memberof lslFrame
         * @interface IlslVector
         * @property {Array.<number>|null} [coords] lslVector coords
         */

        /**
         * Constructs a new lslVector.
         * @memberof lslFrame
         * @classdesc Represents a lslVector.
         * @implements IlslVector
         * @constructor
         * @param {lslFrame.IlslVector=} [properties] Properties to set
         */
        function lslVector(properties) {
            this.coords = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * lslVector coords.
         * @member {Array.<number>} coords
         * @memberof lslFrame.lslVector
         * @instance
         */
        lslVector.prototype.coords = $util.emptyArray;

        /**
         * Creates a new lslVector instance using the specified properties.
         * @function create
         * @memberof lslFrame.lslVector
         * @static
         * @param {lslFrame.IlslVector=} [properties] Properties to set
         * @returns {lslFrame.lslVector} lslVector instance
         */
        lslVector.create = function create(properties) {
            return new lslVector(properties);
        };

        /**
         * Encodes the specified lslVector message. Does not implicitly {@link lslFrame.lslVector.verify|verify} messages.
         * @function encode
         * @memberof lslFrame.lslVector
         * @static
         * @param {lslFrame.IlslVector} message lslVector message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        lslVector.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.coords != null && message.coords.length) {
                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                for (var i = 0; i < message.coords.length; ++i)
                    writer.float(message.coords[i]);
                writer.ldelim();
            }
            return writer;
        };

        /**
         * Encodes the specified lslVector message, length delimited. Does not implicitly {@link lslFrame.lslVector.verify|verify} messages.
         * @function encodeDelimited
         * @memberof lslFrame.lslVector
         * @static
         * @param {lslFrame.IlslVector} message lslVector message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        lslVector.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a lslVector message from the specified reader or buffer.
         * @function decode
         * @memberof lslFrame.lslVector
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {lslFrame.lslVector} lslVector
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        lslVector.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.lslFrame.lslVector();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 3: {
                        if (!(message.coords && message.coords.length))
                            message.coords = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.coords.push(reader.float());
                        } else
                            message.coords.push(reader.float());
                        break;
                    }
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a lslVector message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof lslFrame.lslVector
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {lslFrame.lslVector} lslVector
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        lslVector.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a lslVector message.
         * @function verify
         * @memberof lslFrame.lslVector
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        lslVector.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.coords != null && message.hasOwnProperty("coords")) {
                if (!Array.isArray(message.coords))
                    return "coords: array expected";
                for (var i = 0; i < message.coords.length; ++i)
                    if (typeof message.coords[i] !== "number")
                        return "coords: number[] expected";
            }
            return null;
        };

        /**
         * Creates a lslVector message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof lslFrame.lslVector
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {lslFrame.lslVector} lslVector
         */
        lslVector.fromObject = function fromObject(object) {
            if (object instanceof $root.lslFrame.lslVector)
                return object;
            var message = new $root.lslFrame.lslVector();
            if (object.coords) {
                if (!Array.isArray(object.coords))
                    throw TypeError(".lslFrame.lslVector.coords: array expected");
                message.coords = [];
                for (var i = 0; i < object.coords.length; ++i)
                    message.coords[i] = Number(object.coords[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a lslVector message. Also converts values to other types if specified.
         * @function toObject
         * @memberof lslFrame.lslVector
         * @static
         * @param {lslFrame.lslVector} message lslVector
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        lslVector.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.coords = [];
            if (message.coords && message.coords.length) {
                object.coords = [];
                for (var j = 0; j < message.coords.length; ++j)
                    object.coords[j] = options.json && !isFinite(message.coords[j]) ? String(message.coords[j]) : message.coords[j];
            }
            return object;
        };

        /**
         * Converts this lslVector to JSON.
         * @function toJSON
         * @memberof lslFrame.lslVector
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        lslVector.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * Gets the default type url for lslVector
         * @function getTypeUrl
         * @memberof lslFrame.lslVector
         * @static
         * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
         * @returns {string} The default type url
         */
        lslVector.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
            if (typeUrlPrefix === undefined) {
                typeUrlPrefix = "type.googleapis.com";
            }
            return typeUrlPrefix + "/lslFrame.lslVector";
        };

        return lslVector;
    })();

    return lslFrame;
})();

$root.lslMessage = (function() {

    /**
     * Properties of a lslMessage.
     * @exports IlslMessage
     * @interface IlslMessage
     * @property {string} streamName lslMessage streamName
     * @property {IlslFrame} payload lslMessage payload
     */

    /**
     * Constructs a new lslMessage.
     * @exports lslMessage
     * @classdesc Represents a lslMessage.
     * @implements IlslMessage
     * @constructor
     * @param {IlslMessage=} [properties] Properties to set
     */
    function lslMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * lslMessage streamName.
     * @member {string} streamName
     * @memberof lslMessage
     * @instance
     */
    lslMessage.prototype.streamName = "";

    /**
     * lslMessage payload.
     * @member {IlslFrame} payload
     * @memberof lslMessage
     * @instance
     */
    lslMessage.prototype.payload = null;

    /**
     * Creates a new lslMessage instance using the specified properties.
     * @function create
     * @memberof lslMessage
     * @static
     * @param {IlslMessage=} [properties] Properties to set
     * @returns {lslMessage} lslMessage instance
     */
    lslMessage.create = function create(properties) {
        return new lslMessage(properties);
    };

    /**
     * Encodes the specified lslMessage message. Does not implicitly {@link lslMessage.verify|verify} messages.
     * @function encode
     * @memberof lslMessage
     * @static
     * @param {IlslMessage} message lslMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    lslMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        writer.uint32(/* id 1, wireType 2 =*/10).string(message.streamName);
        $root.lslFrame.encode(message.payload, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified lslMessage message, length delimited. Does not implicitly {@link lslMessage.verify|verify} messages.
     * @function encodeDelimited
     * @memberof lslMessage
     * @static
     * @param {IlslMessage} message lslMessage message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    lslMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a lslMessage message from the specified reader or buffer.
     * @function decode
     * @memberof lslMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {lslMessage} lslMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    lslMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.lslMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.streamName = reader.string();
                    break;
                }
            case 2: {
                    message.payload = $root.lslFrame.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        if (!message.hasOwnProperty("streamName"))
            throw $util.ProtocolError("missing required 'streamName'", { instance: message });
        if (!message.hasOwnProperty("payload"))
            throw $util.ProtocolError("missing required 'payload'", { instance: message });
        return message;
    };

    /**
     * Decodes a lslMessage message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof lslMessage
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {lslMessage} lslMessage
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    lslMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a lslMessage message.
     * @function verify
     * @memberof lslMessage
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    lslMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (!$util.isString(message.streamName))
            return "streamName: string expected";
        {
            var error = $root.lslFrame.verify(message.payload);
            if (error)
                return "payload." + error;
        }
        return null;
    };

    /**
     * Creates a lslMessage message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof lslMessage
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {lslMessage} lslMessage
     */
    lslMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.lslMessage)
            return object;
        var message = new $root.lslMessage();
        if (object.streamName != null)
            message.streamName = String(object.streamName);
        if (object.payload != null) {
            if (typeof object.payload !== "object")
                throw TypeError(".lslMessage.payload: object expected");
            message.payload = $root.lslFrame.fromObject(object.payload);
        }
        return message;
    };

    /**
     * Creates a plain object from a lslMessage message. Also converts values to other types if specified.
     * @function toObject
     * @memberof lslMessage
     * @static
     * @param {lslMessage} message lslMessage
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    lslMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.streamName = "";
            object.payload = null;
        }
        if (message.streamName != null && message.hasOwnProperty("streamName"))
            object.streamName = message.streamName;
        if (message.payload != null && message.hasOwnProperty("payload"))
            object.payload = $root.lslFrame.toObject(message.payload, options);
        return object;
    };

    /**
     * Converts this lslMessage to JSON.
     * @function toJSON
     * @memberof lslMessage
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    lslMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for lslMessage
     * @function getTypeUrl
     * @memberof lslMessage
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    lslMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/lslMessage";
    };

    return lslMessage;
})();

$root.lslChunk = (function() {

    /**
     * Properties of a lslChunk.
     * @exports IlslChunk
     * @interface IlslChunk
     * @property {Array.<IlslFrame>|null} [frames] lslChunk frames
     */

    /**
     * Constructs a new lslChunk.
     * @exports lslChunk
     * @classdesc Represents a lslChunk.
     * @implements IlslChunk
     * @constructor
     * @param {IlslChunk=} [properties] Properties to set
     */
    function lslChunk(properties) {
        this.frames = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * lslChunk frames.
     * @member {Array.<IlslFrame>} frames
     * @memberof lslChunk
     * @instance
     */
    lslChunk.prototype.frames = $util.emptyArray;

    /**
     * Creates a new lslChunk instance using the specified properties.
     * @function create
     * @memberof lslChunk
     * @static
     * @param {IlslChunk=} [properties] Properties to set
     * @returns {lslChunk} lslChunk instance
     */
    lslChunk.create = function create(properties) {
        return new lslChunk(properties);
    };

    /**
     * Encodes the specified lslChunk message. Does not implicitly {@link lslChunk.verify|verify} messages.
     * @function encode
     * @memberof lslChunk
     * @static
     * @param {IlslChunk} message lslChunk message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    lslChunk.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.frames != null && message.frames.length)
            for (var i = 0; i < message.frames.length; ++i)
                $root.lslFrame.encode(message.frames[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified lslChunk message, length delimited. Does not implicitly {@link lslChunk.verify|verify} messages.
     * @function encodeDelimited
     * @memberof lslChunk
     * @static
     * @param {IlslChunk} message lslChunk message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    lslChunk.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a lslChunk message from the specified reader or buffer.
     * @function decode
     * @memberof lslChunk
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {lslChunk} lslChunk
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    lslChunk.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.lslChunk();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.frames && message.frames.length))
                        message.frames = [];
                    message.frames.push($root.lslFrame.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a lslChunk message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof lslChunk
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {lslChunk} lslChunk
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    lslChunk.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a lslChunk message.
     * @function verify
     * @memberof lslChunk
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    lslChunk.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.frames != null && message.hasOwnProperty("frames")) {
            if (!Array.isArray(message.frames))
                return "frames: array expected";
            for (var i = 0; i < message.frames.length; ++i) {
                var error = $root.lslFrame.verify(message.frames[i]);
                if (error)
                    return "frames." + error;
            }
        }
        return null;
    };

    /**
     * Creates a lslChunk message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof lslChunk
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {lslChunk} lslChunk
     */
    lslChunk.fromObject = function fromObject(object) {
        if (object instanceof $root.lslChunk)
            return object;
        var message = new $root.lslChunk();
        if (object.frames) {
            if (!Array.isArray(object.frames))
                throw TypeError(".lslChunk.frames: array expected");
            message.frames = [];
            for (var i = 0; i < object.frames.length; ++i) {
                if (typeof object.frames[i] !== "object")
                    throw TypeError(".lslChunk.frames: object expected");
                message.frames[i] = $root.lslFrame.fromObject(object.frames[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a lslChunk message. Also converts values to other types if specified.
     * @function toObject
     * @memberof lslChunk
     * @static
     * @param {lslChunk} message lslChunk
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    lslChunk.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.frames = [];
        if (message.frames && message.frames.length) {
            object.frames = [];
            for (var j = 0; j < message.frames.length; ++j)
                object.frames[j] = $root.lslFrame.toObject(message.frames[j], options);
        }
        return object;
    };

    /**
     * Converts this lslChunk to JSON.
     * @function toJSON
     * @memberof lslChunk
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    lslChunk.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Gets the default type url for lslChunk
     * @function getTypeUrl
     * @memberof lslChunk
     * @static
     * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
     * @returns {string} The default type url
     */
    lslChunk.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/lslChunk";
    };

    return lslChunk;
})();

module.exports = $root;
